import React from 'react'

import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import Map from '../ContactUS/Map'


function ContactUS() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="About IIT Tirupati Logo" />


            <section id="services" className="team-area fix p-relative pt-120 pb-80">
                {/*   */}
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title text-center mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s" >
                                <h5>
                                    <i className="fal fa-graduation-cap" /> About 
                                </h5>
                                <h2>IIT Tirupati Logo</h2>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <div className="section-title text-center mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".2s" >
                                <img src="https://files.iittp.ac.in/images/demo/iit/Other/LOGOtotal.png" alt=" logo " />   
                            </div>
                        </div>

                        <div className="col-lg-12 col-md-12 text-dark ">
                            <p className='fs-6 lh-lg border border-warning p-5'>IIT Tirupati Logo was designed and developed by Mr. Chakradhar Saswade who is currently a Senior Designer, Discipline Lead of Information Design from the National Institute of Design, R&D Campus, Bangalore. The Logo represents the visual identity of IIT Tirupati, that is, it combines the letters of its acronym and a series of symbolic images along with it. They complement and present a unique and beautiful image, one that stands as a sign and conveys the layers of attributes of this premier institute of the country as an entity. </p>
                        </div>
                    </div>
                </div>




            </section>
        </>
    )
}

export default ContactUS